import { render, staticRenderFns } from "./PayRoll.vue?vue&type=template&id=74f257d2&"
import script from "./PayRoll.vue?vue&type=script&lang=js&"
export * from "./PayRoll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports